import { action } from 'mobx';
import { browserHistory } from 'react-router';
import FetchService from '../../../core/services/FetchService';
import FormService from '../../../core/services/FormService';
import NotificationService from '../../../core/services/NotificationService';
import { isRequired } from '../../../core/validations';
import { Roles } from '../../../core/util';

export default class ModuleCustomizationFormService {
  submit = new FetchService();
  form = new FormService();

  constructor() {
    this.form.validations = {
      course: [isRequired],
      module: [isRequired],
      file: [isRequired],
      ...(localStorage.role === Roles.ADMIN && { distributor: [isRequired] }),
    };
  }

  handleSubmit = action(() => {
    this.form.submitted = true;
    if (this.form.errors) {
      NotificationService.addNotification('Fill the required fields', 'error');
      return;
    }

    const formValues = this.form.getValues();
    const formData = new FormData();
    formData.append('module', formValues.module);
    formData.append('file', formValues.file);
    if (localStorage.role === Roles.ADMIN) {
      formData.append('distributor', formValues.distributor);
    }

    this.submit
      .fetch({
        method: 'post',
        apiVersion: 'v3',
        url: '/module-customizations',
        body: formData,
      })
      .then(() => {
        if (this.submit.data) {
          NotificationService.addNotification('Module Customization created successfully.', 'success');
          browserHistory.push('/module-customizations');
        }
        if (this.submit.error) {
          NotificationService.addNotification(this.submit.error, 'error');
        }
      });
  });
}
